import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import Tokenomics from "./Tokenomics";


function Home2() {
  return (
    <Container fluid className="home-about-section" id="about">
      <Container>
        <Row>
          <Col md={12} className="home-about-description" >
            <div className="dreamit-section-title"><h4 style={{ fontSize: "2rem"}}>Fontana</h4></div>
              <h1 style={{ fontSize: "1.6rem",  paddingBottom: "1rem"}}>           
              <span className="purple"> Tokenomics  </span> 
              </h1>
            
                <Tokenomics/>
              
             
               <p className="text-secondary small">** While the core principles and objectives of Fontana are intended to 
               remain constant, the specifics of the ecosystem, particularly those related to the FONTANA, LUMINA, and Cerulean tokens, are subject to ongoing updates and refinements.
               </p>
          </Col>
         
        </Row> 
      
      </Container>
    </Container>
  );
}
export default Home2;
